<template>
<div>
  <b-alert v-model="showVerifyCodeSuccess" variant="success" dismissible>
    User <strong>{{uid}}</strong> successfully confirmed.
  </b-alert>
  <b-alert v-model="showVerifyCodeFailure" variant="danger" dismissible>
    <strong>ERROR:</strong> {{error}}
  </b-alert>
  <br />
  <p class="text-center">
    <router-link to="/">Return to index</router-link>
  </p>
</div>
</template>

<script>
import client from 'api-client';

export default {
  data() {
    return {
      showVerifyCodeSuccess: false,
      uid: null,
      showVerifyCodeFailure: false,
      error: null
    };
  },
  mounted() {
    this.showVerifyCodeSuccess = false;
    this.uid = null;
    this.showVerifyCodeFailure = false;
    this.error = null;
    this.$store.commit('setConfirmationLinkEmail', null);
    client.verifyCode(this.$route.params.code)
      .then(res => {
        this.uid = res.uid;
        this.showVerifyCodeSuccess = true;
      })
      .catch(res => {
        this.error = res.message;
        this.showVerifyCodeFailure = true;
      });
  }
};
</script>
